import React, { Suspense, useEffect } from "react"
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { Fragment, lazy, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AuthGuard from "./AuthGuard";
import HideFromUW from "./components/common/HideFromUW.js";
import { SnackBarProvider } from "./components/common/snackbar/SmeSnackbar";
import CompanyDetails from "./components/company-details";
import Dashboard from "./components/dashboard";
import LeadPrefillWrapper from "./components/lead-prefill-wrapper";
import SessionExpired from "./components/modals/SessionExpired";
import Notfound from "./components/notfound";
import Quote from "./components/quote";
import "./homepage.css";
import ProtectedRoute from "./protectedRoute";
import { CommonDataProvider } from "./utils/commonProvider";
import CookiesHelper from "./utils/cookiesHelper";
import useMediaQuery from "@mui/material/useMediaQuery";
import Stack from "@mui/material/Stack"
import 'swiper/css';
import 'swiper/css/pagination';
import { retryRemoteComponent } from "./utils/federationHelper";

const HeaderModuleDesktop = lazy(() =>
  retryRemoteComponent(() => import("AtomCommonApp/HeaderModule"))
);
const AtomMobileHeader = lazy(() =>
  retryRemoteComponent(() => import("AtomCommonApp/AtomMobileHeader"))
);
const SidebarModule = lazy(() =>
  retryRemoteComponent(() => import("AtomCommonApp/AtomMobileSidebar"))
);

// const HeaderModuleDesktop = lazy(() => import('AtomCommonApp/HeaderModule'))
// const AtomMobileHeader = lazy(() => import('AtomCommonApp/AtomMobileHeader'))
// const SidebarModule = lazy(() => import('AtomCommonApp/AtomMobileSidebar'))

const App = () => {
  const isMobileScreen = useMediaQuery('(max-width:952px)');

  const [isSessionExpired, setIsSessionExpired] = useState(false)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [branchName, setBranchName] = useState('')
const [storedChannel, setStoredChannel] = useState("");

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const channel = params.get("channel");

  if (channel) {
    setStoredChannel(channel);
    localStorage.setItem("app_channel", channel);
  } else {
    const saved = localStorage.getItem("app_channel");
    if (saved) setStoredChannel(saved);
  }
}, []);
  const handleSession = (value) => {
    setIsSessionExpired(value ? value : true)
  }
  const navigate = useNavigate()
  const location = useLocation();
  const currentRoute = location.pathname;
  const isDashBoardPage = currentRoute === '/dashboard';
  const dashboardHandler = () => {
    navigate("/dashboard");
  };
  const loginId = CookiesHelper.getUserProfile().firstName || ""
  const homeHandler = () => {
    navigate("/company-details");
  };
  const userDropdownList = [{
    id: 0,
    text: CookiesHelper.getUserId(),
    type: 'link',
    callBack: () => {
    },
    isVisible: true,
    icon: "https://cdn.starhealth.in/assets/commonIcons/atomCommon/user.svg",
  }]
  const HeaderModule = isMobileScreen ? AtomMobileHeader : HeaderModuleDesktop
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen)
  return (
    <CommonDataProvider>
      <SnackBarProvider>

        <AuthGuard sessionHandler={handleSession} setBranchName={setBranchName}>
          <Fragment>
            <link rel="stylesheet" href="/css/fontello.css"></link>
            <div className="WebLoader d-none">
              <div className="LoaderImg"></div>
            </div>
            <div className="MainPageSection">
              <Suspense fallback={<></>}>
                <HeaderModule
                  headerTitle={`Hi, ${CookiesHelper.getUserProfile().firstName}`}
                  entity={CookiesHelper.getEntity()}
                  ssoClientId="atom"
                  showProfile={true}
                  dynamicLogoAnchor={
                    process.env.REACT_APP_VO_URL
                  }
                  userProfileCallBack={toggleSidebar}
                  userDropdownList={userDropdownList}
                  // navigationRightList={[{
                  //   id: 0, title: isDashBoardPage ?
                  //     <img
                  //       src="/images/home-icon.svg"
                  //       height="46px"
                  //       width="46px"
                  //       alt="Home Icon"
                  //       title="HOME"
                  //       className="Rounded10 d-inline-block mr-3"
                  //       onClick={homeHandler}
                  //       style={{ cursor: 'pointer', padding: '10px', background: '#f2f4f7', width: 'auto' }}
                  //     />

                  //     : <button
                  //       title="Dashboard"
                  //       aria-label="Dashboard"
                  //       className="btn badge BadgeLiteBlue BadgeDashboardIcon Rounded10 d-inline-block mr-3"
                  //       onClick={dashboardHandler}
                  //     ></button>, callBack: () => {
                  //     }
                  // }]}
                  showSupport={true}
                  rightActionButton={{ icon: isDashBoardPage ?  "https://cdn.starhealth.in/assets/atom-new/sidebar-icon/homeIcon.svg":"https://sit-atompro.starhealth.in/v1/dashboard.svg" , callBack: () => isDashBoardPage ? homeHandler() : dashboardHandler() }}
                />
              </Suspense>
              <Stack flexDirection={"row"} height={"calc(100vh - 72px)"} overflow={"hidden"}>
                <SidebarModule
                  showSideBar={true}
                  ssoClientId="atom"
                  entity={CookiesHelper.getEntity()}
                  isSidebarOpen={isSidebarOpen}
                  toggleSidebar={toggleSidebar}
                  navigationLeftList={isMobileScreen ? [{
  label: "ATOM Home",
  route: "/",
  icon: "https://cdn.starhealth.in/assets/atom-new/sidebar-icon/homeIcon.svg",
  order: 1,
  default: false,
  callBack: () => {
    const currentChannel =
      storedChannel || localStorage.getItem("app_channel");

    window.location.replace(
      (process.env.REACT_APP_VO_URL || "") +
        (
          currentChannel === "banca"
            ? "/banca/home"
            : currentChannel === "alternate"
            ? "/alternate/home"
            : "/v1/home"
        )
    );
  }
}] : [{
                    "text": "Home",
                    "route": "/home",
                    "icon": "https://cdn.starhealth.in/assets/atom-new/sidebar-icon/homeIcon.svg",
                    "order": 1,
                    "default": false,
                    callBack: () => window.location.replace(process.env.REACT_APP_VO_URL)
                  }]}
                  profileData={{
                    "userName": CookiesHelper.getUserProfile().firstName,
                    "clubName": "",
                    "clubIcon": "",
                    "userEmail": CookiesHelper.getUserId() || "User ID"
                  }} />
                <Stack width={"100%"} overflow={"scroll"}>
                  <Typography textAlign={'center'} padding={'12px'} variant="h6" fontWeight={700}>GMC Quick Quote</Typography>
                  <Divider variant="middle" />
                  <Routes>
                    <Route
                      path="/dashboard"
                      element={
                        <ProtectedRoute sessionHandler={handleSession}>
                          <Dashboard sessionHandler={handleSession} />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      index
                      path="/company-details"
                      element={
                        <ProtectedRoute sessionHandler={handleSession}>
                          <HideFromUW>
                            <CompanyDetails sessionHandler={handleSession} branchName={branchName} />
                          </HideFromUW>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="lead"
                      element={
                        <ProtectedRoute sessionHandler={handleSession}>
                          <HideFromUW>
                            <LeadPrefillWrapper sessionHandler={handleSession} />
                          </HideFromUW>

                        </ProtectedRoute>
                      }
                    />
                    <Route path="*" element={<ProtectedRoute sessionHandler={handleSession}><Notfound /></ProtectedRoute>} />
                    <Route
                      path="quote"
                      element={
                        <ProtectedRoute sessionHandler={handleSession}>
                          <HideFromUW>
                            <Quote sessionHandler={handleSession} />
                          </HideFromUW>

                        </ProtectedRoute>
                      }
                    />
                    {/* <Route
                      path="/error" element={ExternalRedirect({url:process.env.REACT_APP_VO_URL})}/> */}
                  </Routes>

                  {isSessionExpired && <SessionExpired />}
                </Stack>
              </Stack>

            </div>
          </Fragment>
        </AuthGuard>
      </SnackBarProvider>
    </CommonDataProvider>
  );
};

export default App;
